import { component as defineComponent } from 'flightjs'; // eslint-disable-line no-restricted-imports

export default defineComponent(Presence);

function Presence() {
    this.attributes({
        presenceEvent: 'uiUserPresent',
        presenceImage: null,
    });

    this.after('initialize', function() {
        $(document).on(this.attr.presenceEvent, this.handlePresenceEvent.bind(this));
    });

    this.handlePresenceEvent = function() {
        new Image().src = this.attr.presenceImage;
    };
}



// WEBPACK FOOTER //
// ./src/js/flight/ui/presence.js